import { render, staticRenderFns } from "./jump2.vue?vue&type=template&id=001483fa&scoped=true"
import script from "./jump2.vue?vue&type=script&lang=js"
export * from "./jump2.vue?vue&type=script&lang=js"
import style0 from "./jump2.vue?vue&type=style&index=0&id=001483fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001483fa",
  null
  
)

export default component.exports